import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ManagementComponent } from './pages/management/management.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'management', component: ManagementComponent },
];
